export default class HelperFuntions {
    /**
     * Here we trasform the array into a string to pass it ass a filter
     * @param data 
     * @returns 
     */
    static ArrayToFilterString(data: Array<string>): string {
        return data.join(', ')
    }
}